export const NODE_TYPE_TO_INLINE_DELIMITER_MAP = {
  strong: '**',
  emphasis: '_',
  inlineCode: '`',
  delete: '~~',
  link: {prefix: '[', suffix: ']()'},
} as const
export type FormatInlineNodeType = keyof typeof NODE_TYPE_TO_INLINE_DELIMITER_MAP

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6

export type FormatNodeType = FormatInlineNodeType | 'blockquote' | 'heading'
